import { Pipe, PipeTransform } from '@angular/core';
import { isNumber } from 'util';

@Pipe({
  name: 'doubleValue'
})
export class DoubleValuePipe implements PipeTransform {

  transform(value: any): any {
    if(isNumber(value)){
      return value * 2;
    }

    return value;
  }

}
